export const buildGoogleOverwritedRedirectionUrl = (navigationContext, redirectionUrl, currentUrl) => navigationContext === 'page'
    ? redirectionUrl || '/'
    : redirectionUrl || currentUrl;
//# sourceMappingURL=buildGoogleOverwritedRedirectionUrl.js.map